import { BaseError } from './base';

export class InvalidRedirectStorageStateError extends BaseError {
  constructor() {
    super({
      cause: null,
      code: 'invalid_redirect_storage_state_error',
      docsUrl: null,
      name: 'InvalidRedirectStorageStateError',
      shortMessage:
        'The social redirect data found in local storage does not match the expected state. Try connecting again.',
    });
  }
}
